import { useRef, useState } from "react";
import { motion } from "framer-motion";

// Magnetic button — pulls toward the cursor on hover.
export const MagneticButton = ({ children, className = "", as = "button", strength = 0.35, ...props }) => {
  const ref = useRef(null);
  const [pos, setPos] = useState({ x: 0, y: 0 });
  const Comp = motion[as] || motion.button;

  const handleMove = (e) => {
    const rect = ref.current.getBoundingClientRect();
    const x = (e.clientX - (rect.left + rect.width / 2)) * strength;
    const y = (e.clientY - (rect.top + rect.height / 2)) * strength;
    setPos({ x, y });
  };

  return (
    <Comp
      ref={ref}
      onMouseMove={handleMove}
      onMouseLeave={() => setPos({ x: 0, y: 0 })}
      animate={{ x: pos.x, y: pos.y }}
      transition={{ type: "spring", stiffness: 250, damping: 18, mass: 0.4 }}
      className={className}
      {...props}
    >
      {children}
    </Comp>
  );
};

export default MagneticButton;
